import React, {useContext, useState} from "react";
import {AspectRatio, Box, Button, Container, Divider, FormControl, FormLabel, Input, Sheet, Stack, Typography} from "@mui/joy";
import {FeedbackContext} from "../utils/FeedbackContext";
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import {Email, Key, Visibility, VisibilityOff} from "@mui/icons-material";
import AppleIcon from "@mui/icons-material/Apple";
import GoogleIcon from "@mui/icons-material/Google";
import {useLocation} from "react-router-dom";
import {projectTitle} from "../utils/Utils";


export function Login() {

    const {loading, setError} = useContext(FeedbackContext)
    enum TABS {
        LOGIN,
        RESET_PSW,
        CONFIRM_RESET_PSW,
    }
    const location = useLocation()

    const [tab, setTab] = useState<TABS>(TABS.LOGIN)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [pswvisible, setPswvisible] = useState(false)

    switch (tab) {
        case TABS.LOGIN :
            return (
                <Box sx={{height: '100vh'}}>
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>
                            <Box sx={{ display: 'flex', gap: 1, flexDirection:"column", justifyContent:"center", alignItems: 'center' }}>
                                <Typography level="h2">{projectTitle}</Typography>
                            </Box>

                            <Stack direction="column" spacing={1.5}>
                                <Button variant="outlined"
                                        color="neutral"
                                        startDecorator={<GoogleIcon />}
                                        onClick={() => SignInWithGoogle(location.state)}
                                        disabled={loading}
                                >
                                    Accedi con Google
                                </Button>
                                <Button variant="outlined"
                                        color="neutral"
                                        startDecorator={<AppleIcon />}
                                        onClick={() => SignInWithApple(location.state)}
                                        disabled={loading}
                                >
                                    Accedi con Apple
                                </Button>
                            </Stack>

                            <Divider>oppure</Divider>

                            <FormControl>
                                <FormLabel>
                                    Email
                                </FormLabel>
                                <Input type="email"
                                       placeholder="nome@email.com"
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                                       startDecorator={<Email />}
                                       onKeyDown={(event) => {
                                           if (event.key === 'Enter') {
                                               SignIn(email, password, location.state).then(() => {})
                                           }
                                       }}
                                       autoFocus
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Password
                                </FormLabel>
                                <Input type={pswvisible ? "text" : "password"}
                                       placeholder="********"
                                       value={password}
                                       onChange={(e) => setPassword(e.target.value)}
                                       startDecorator={<Key />}
                                       endDecorator={
                                           pswvisible ?
                                               <VisibilityOff onClick={() => setPswvisible(!pswvisible)} />
                                               :
                                               <Visibility onClick={() => setPswvisible(!pswvisible)} />
                                       }
                                       onKeyDown={(event) => {
                                           if (event.key === 'Enter') {
                                               SignIn(email, password, location.state).then(() => {})
                                           }
                                       }}
                                />
                            </FormControl>
                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => SignIn(email, password, location.state)}
                                    disabled={!email || !password || loading}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            SignIn(email, password, location.state).then(() => {})
                                        }
                                    }}
                            >
                                Accedi
                            </Button>

                            <Typography level="body-sm" textAlign="center" className="link" onClick={() => setTab(TABS.RESET_PSW)}>
                                Ho dimenticato la password
                            </Typography>
                        </Stack>
                    </Container>
                </Box>
            )
        case TABS.RESET_PSW :
            return (
                <Box sx={{height: '100vh'}}>
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>

                            <Box sx={{ display: 'flex', gap: 1, flexDirection:"column", justifyContent:"center", alignItems: 'center' }}>
                                <Typography level="h2">{projectTitle}</Typography>
                            </Box>
                            <Box sx={{display:"flex", justifyContent:"center"}}>

                            </Box>

                            <Typography level="body-sm" className="link" onClick={() => setTab(TABS.LOGIN)}>
                                &larr; Indietro
                            </Typography>

                            <FormControl>
                                <FormLabel>
                                    Email
                                </FormLabel>
                                <Input type="email"
                                       placeholder="nome@email.com"
                                       value={email}
                                       onChange={(e) => setEmail(e.target.value)}
                                       startDecorator={<Email />}
                                />
                            </FormControl>

                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => ResetPsw(email)}
                                    disabled={!email || loading}
                            >
                                Reimposta password
                            </Button>

                        </Stack>
                    </Container>
                </Box>
            )
        case TABS.CONFIRM_RESET_PSW :
            return (
                <Box sx={{height: '100vh'}}>
                    <Container maxWidth="sm" sx={{height: '100%', display:"flex", alignItems:"center"}}>
                        <Stack direction="column" spacing={2} sx={{width:"100%"}}>

                            <Typography level="body-md" textAlign="center" >
                                Ti abbiamo inviato una mail con le istruzioni per il reset della password
                            </Typography>

                            <Button variant="solid"
                                    color="primary"
                                    onClick={() => setTab(TABS.LOGIN)}
                            >
                                Torna al login
                            </Button>

                        </Stack>
                    </Container>
                </Box>
            )
    }


    async function SignIn(email: string, password: string, url: { from: string } | null) {
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password)
            if(url) window.location.replace(url.from)
        } catch (e: unknown) {
            setError(e)
        }
    }
    async function SignInWithGoogle(url: { from: string } | null) {
        try {
            await firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider())
            if(url) window.location.replace(url.from)
        } catch (e: unknown) {
            setError(e)
        }
    }
    async function SignInWithApple(url: { from: string } | null) {
        try {
            const provider = new firebase.auth.OAuthProvider('apple.com')
            provider.addScope('email')
            provider.addScope('name')
            await firebase.auth().signInWithPopup(provider)
            if(url) window.location.replace(url.from)
        } catch (e: unknown) {
            setError(e)
        }
    }
    async function ResetPsw(email: string) {
        try {
            await firebase.auth().sendPasswordResetEmail(email)
            setTab(TABS.CONFIRM_RESET_PSW)
        } catch (e: unknown) {
            setError(e)
        }
    }
}